"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const mediaElements = document.querySelectorAll('.gr-media-with-steps__media');
  mediaElements.forEach(element => {
    const videos = element.querySelectorAll('.gr-media--video');
    videos.forEach(video => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const isVisible = window.getComputedStyle(video).display !== 'none';
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2 && isVisible) {
            document.querySelectorAll('.gr-media--video').forEach(v => {
              if (v !== video && !v.paused) {
                v.pause();
              }
            });
            if (video.paused) {
              video.play();
            }
          } else {
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }, {
        threshold: [0.2]
      });
      observer.observe(video);
    });
  });
});

/* The animated bottle (snippets/gr-steps-scene) runs on CSS alone. Here: a click on a step restarts the loop
   from that step, and the loop is paused while the section is off screen. */
document.addEventListener("DOMContentLoaded", () => {
  const CYCLE = 12; /* seconds — keep equal to --hiw-t in section-gr-media-with-steps.css */
  document.querySelectorAll("[data-steps-scene]").forEach(root => {
    root.querySelectorAll("[data-steps-scene-step]").forEach(item => {
      item.addEventListener("click", () => {
        const step = parseInt(item.getAttribute("data-steps-scene-step"), 10) || 1;
        root.classList.remove("is-running");
        root.style.setProperty("--hiw-delay", -(step - 1) * CYCLE / 3 + "s");
        void root.offsetWidth; /* reflow, so the animations really start again */
        root.classList.add("is-running");
      });
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(entries => {
        root.classList.toggle("is-paused", !entries[0].isIntersecting);
      }, {
        threshold: 0.15
      }).observe(root);
    }
  });
});
